$.fn.RollingBanner = function() {
  let self = this
  let original_content = self.html();

  self.initRolling = function() {
    self.html('<span>' + original_content + '</span>')

    let first_element = self.find('span').first();
    var element_width = first_element.width();
    var window_width = $(window).width();

    if (element_width < window_width) {
      var multiplier = Math.ceil(window_width / element_width)
      for (let i = 0; i < multiplier; i++) {
        first_element.html(first_element.html() + original_content)
      }
    }

    first_element.clone().appendTo(self);
    self.css('--duration', (first_element.width() / 100) + 's')
  }
  self.initRolling();

  return function() {
    $(window).on('resize orientationchange load', self.initRolling)
    return self
  }()
}
